export const MIN_DINNER_RECIPES = 2;
export const MAX_DINNER_RECIPES_2_SERVINGS = 7;
export const MAX_DINNER_RECIPES_4_SERVINGS = 4;
